<div class="d-flex flex-column">
  <label class="menu-label">{{ 'COMMON.Filter' | translate }}</label>
  <div class="d-flex">
    <app-date-range-filter
      [options]="rangeOptions"
      [value]="value || 'current_month'"
      [start]="customStart"
      [end]="customEnd"
      (presetChange)="onRangePreset($event)"
      (customRangeChange)="onRangeCustom($event)"
    ></app-date-range-filter>
    @if (showSaveFilterFlag) {
      <div class="d-flex ml-2">
        <div class="d-flex gap-2 align-items-center" type="button">
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2925_58626)">
              <path
                d="M5.74377 13.1026C5.60059 13.2466 5.40523 13.327 5.20231 13.327C4.99938 13.327 4.80403 13.2466 4.66085 13.1026L0.336574 8.77761C-0.112191 8.32884 -0.112191 7.60114 0.336574 7.15322L0.878037 6.61162C1.32694 6.16285 2.0538 6.16285 2.50257 6.61162L5.20231 9.3115L12.4974 2.01626C12.9463 1.5675 13.6739 1.5675 14.1219 2.01626L14.6634 2.55786C15.1122 3.00663 15.1122 3.73419 14.6634 4.18225L5.74377 13.1026Z"
                fill="#22BC31"
              />
            </g>
            <defs>
              <clipPath id="clip0_2925_58626">
                <rect width="15" height="15" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p class="color-2 m-0" type="button" (click)="saveFilter(value)">
            {{ 'COMMON.Save_Filter' | translate }}
          </p>
        </div>
      </div>
    }
  </div>
</div>
